<h2 class="sr-only">{{ "ErweiterteSuche" | translate }}</h2>

<form (ngSubmit)="onSubmit()" [meta]="erweitert" #form="ngForm" column-classes="col-md-4,col-md-8">
  <div class="row">
    <div class="col-md-6 col-xs-12">
      <cap-form-control labelKey="Name">
        <input
          (ngModelChange)="erweitert && (erweitert.name = $event)"
          [ngModel]="erweitert && erweitert.name"
          #name
          id="name"
          name="name"
          type="text" />
      </cap-form-control>
      <cap-form-control labelKey="Vorname">
        <input
          (ngModelChange)="erweitert && (erweitert.vorname = $event)"
          [ngModel]="erweitert && erweitert.vorname"
          id="vorname"
          name="vorname"
          type="text" />
      </cap-form-control>
      <cap-form-control labelKey="Ledigname">
        <input
          (ngModelChange)="erweitert && (erweitert.ledigname = $event)"
          [ngModel]="erweitert && erweitert.ledigname"
          id="ledigname"
          name="ledigname"
          type="text" />
      </cap-form-control>

      <cap-teil-datum
        (ngModelChange)="erweitert && (erweitert.geburtsdatum = $event)"
        [ngModel]="erweitert && erweitert.geburtsdatum"
        label="Geburtsdatum"
        name="geburtsdatum"></cap-teil-datum>

      <cap-form-control labelKey="Sitz">
        <input
          (ngModelChange)="erweitert && (erweitert.sitz = $event)"
          [ngModel]="erweitert && erweitert.sitz"
          id="sitz"
          name="sitz"
          type="text" />
      </cap-form-control>
    </div>

    <div class="col-md-6 col-xs-12">
      <cap-form-control labelKey="Personart">
        <select
          (ngModelChange)="erweitert && (erweitert.personStammVersionArt = $event)"
          [ngModel]="erweitert && erweitert.personStammVersionArt"
          id="personart"
          name="personart">
          @for (art of personstammArten; track art) {
            <option [ngValue]="art">{{ art | translate }}</option>
          }
        </select>
      </cap-form-control>
      <cap-form-control labelKey="UID">
        <input
          (ngModelChange)="erweitert && (erweitert.uid = $event)"
          [ngModel]="erweitert && erweitert.uid"
          id="uid"
          name="uid"
          type="text" />
      </cap-form-control>
      <cap-form-control labelKey="AHVNummer">
        <input
          (ngModelChange)="erweitert && (erweitert.ahvNummer = $event)"
          [ngModel]="erweitert && erweitert.ahvNummer"
          id="ahvNummer"
          name="ahvNummer"
          type="text" />
      </cap-form-control>
      <cap-form-control labelKey="AHVVersichertennummer">
        <input
          (ngModelChange)="erweitert && (erweitert.ahvVersichertennummer = $event)"
          [ngModel]="erweitert && erweitert.ahvVersichertennummer"
          id="ahvVersichertennummer"
          name="ahvVersichertennummer"
          type="text" />
      </cap-form-control>
      <ng-container>
        <cap-form-row>
          <cap-form-control column-classes="col-md-4, input-series col col-md-7 col-sm px-0" labelKey="StrasseHausNr">
            <input
              (ngModelChange)="erweitert && (erweitert.strasse = $event)"
              [ngModel]="erweitert && erweitert.strasse"
              id="strasse"
              name="strasse"
              type="text" />
          </cap-form-control>
          <cap-form-control column-classes="col-md-4,input-series col col-md-1 col-sm-2 ps-0">
            <input
              (ngModelChange)="erweitert && (erweitert.hausnummer = $event)"
              [ngModel]="erweitert && erweitert.hausnummer"
              id="hausnummer"
              name="hausnummer"
              type="text" />
          </cap-form-control>
        </cap-form-row>
        <cap-form-row>
          <cap-form-control column-classes="col-md-4,input-series col col-md-1 col-sm-2 px-0" labelKey="PlzOrt">
            <input
              (ngModelChange)="erweitert && (erweitert.plz = $event)"
              [ngModel]="erweitert && erweitert.plz"
              id="plz"
              name="plz"
              type="text" />
          </cap-form-control>
          <cap-form-control column-classes="col-md-4,input-series col col-md-7 col-sm ps-0">
            <input
              (ngModelChange)="erweitert && (erweitert.ort = $event)"
              [ngModel]="erweitert && erweitert.ort"
              id="ort"
              name="ort"
              type="text" />
          </cap-form-control>
        </cap-form-row>
      </ng-container>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <h3 class="title-divider">{{ "Rolle" | translate }}</h3>
      <ng-container>
        <div class="col-md-12 row" style="padding: 0px !important">
          <div class="col-md-2">
            <cap-form-control labelKey="Alle">
              <input (click)="updateAlle($event)" [(ngModel)]="alleRollen" name="alleRollen" type="checkbox" />
            </cap-form-control>
          </div>
          <div class="col-md-10">
            <fieldset [disabled]="alleRollen">
              <cap-form-control labelKey="EIGENTUEMER">
                <input
                  (ngModelChange)="erweitert && (erweitert.rolleEigentuemer = $event)"
                  [ngModel]="erweitert && erweitert.rolleEigentuemer"
                  name="rolleEigentuemer"
                  type="checkbox" />
              </cap-form-control>
              <fieldset [disabled]="(erweitert && !erweitert.isSearchUebrigeBerechtigteEnabled) || alleRollen">
                <cap-form-control labelKey="UEBRIGE_BERECHTIGTE">
                  <input
                    (click)="updateUebrigeBerechtigte($event)"
                    [(ngModel)]="alleUebrigeBerechtigte"
                    name="rolleUebrigeBerechtigte"
                    type="checkbox" />
                </cap-form-control>
                <div style="margin-left: 20px">
                  <cap-form-control labelKey="Dienstbarkeit">
                    <input
                      (ngModelChange)="erweitert && (erweitert.rolleUebrigeBerechtigeDienstbarkeit = $event)"
                      [ngModel]="erweitert && erweitert.rolleUebrigeBerechtigeDienstbarkeit"
                      name="rolleUebrigeBerechtigeDienstbarkeit"
                      type="checkbox" />
                  </cap-form-control>
                  <cap-form-control labelKey="Grundlast">
                    <input
                      (ngModelChange)="erweitert && (erweitert.rolleUebrigeBerechtigeGrundlast = $event)"
                      [ngModel]="erweitert && erweitert.rolleUebrigeBerechtigeGrundlast"
                      name="rolleUebrigeBerechtigeGrundlast"
                      type="checkbox" />
                  </cap-form-control>
                  <cap-form-control labelKey="Anmerkung">
                    <input
                      (ngModelChange)="erweitert && (erweitert.rolleUebrigeBerechtigeAnmerkung = $event)"
                      [ngModel]="erweitert && erweitert.rolleUebrigeBerechtigeAnmerkung"
                      name="rolleUebrigeBerechtigeAnmerkung"
                      type="checkbox" />
                  </cap-form-control>
                  <cap-form-control labelKey="Vormerkung">
                    <input
                      (ngModelChange)="erweitert && (erweitert.rolleUebrigeBerechtigeVormerkung = $event)"
                      [ngModel]="erweitert && erweitert.rolleUebrigeBerechtigeVormerkung"
                      name="rolleUebrigeBerechtigeVormerkung"
                      type="checkbox" />
                  </cap-form-control>
                </div>
              </fieldset>
              <cap-form-control labelKey="GLAEUBIGER">
                <input
                  (ngModelChange)="erweitert && (erweitert.rolleGlaeubiger = $event)"
                  [ngModel]="erweitert && erweitert.rolleGlaeubiger"
                  name="rolleGlaeubiger"
                  type="checkbox" />
              </cap-form-control>
              <cap-form-control labelKey="SCHULDNER">
                <input
                  (ngModelChange)="erweitert && (erweitert.rolleSchuldner = $event)"
                  [ngModel]="erweitert && erweitert.rolleSchuldner"
                  name="rolleSchuldner"
                  type="checkbox" />
              </cap-form-control>
            </fieldset>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="col-md-6">
      <cap-history-options
        (ngModelChange)="erweitert && (erweitert.historySearchOptions = $event)"
        [ngModel]="erweitert && erweitert.historySearchOptions"
        name="historySearchOptions"></cap-history-options>
      <ng-container>
        <h3 class="title-divider" style="margin-top: 5px">{{ "elasticsearch.options" | translate }}</h3>
        <cap-form-control [ngbTooltip]="'unscharfeSucheTooltip' | translate" labelKey="unscharfeSuche" placement="left">
          <input
            (ngModelChange)="erweitert && (erweitert.elasticSearchOptions.unscharfeSuche = $event)"
            [ngModel]="erweitert && erweitert.elasticSearchOptions.unscharfeSuche"
            name="elasticsearch.options.unscharfeSuche"
            type="checkbox" />
        </cap-form-control>
      </ng-container>
    </div>
  </div>

  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
      <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
    </div>
  </div>
</form>
